import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';

import { useCreateServiceInterruptionMutation, useZone } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices';
import dayjs from 'dayjs';

interface UseSuspendServiceFormManagerProps {
  zoneId: number;
  next?: (data?: any) => void;
}

export const useSuspendServiceFormManager = ({ zoneId, next = () => {} }: UseSuspendServiceFormManagerProps) => {
  const {
    data: {
      next_cleaning_time: nextCleaningTime = '',
      schedule: schedules = [],
      code = '',
      name: _zoneName = '',
      building_id: buildingId = null,
      building: { address: buildingName = '' } = {},
    } = {},
    isLoading: loading_zone,
  } = useZone({
    zoneId,
  });
  const { id: userId, orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [createServiceInterruption, { isLoading: loading_createServiceInterruption }] =
    useCreateServiceInterruptionMutation();

  const nextSchedule = schedules.find(({ time }) => {
    const [dateString] = nextCleaningTime?.split('T') ?? [''];
    const nextTimestamp = dayjs(nextCleaningTime).valueOf();
    const scheduleTimestamp = dayjs(`${dateString}T${time}`).valueOf();

    return nextTimestamp === scheduleTimestamp;
  });

  const { id: scheduleId = null } = nextSchedule || {};
  const zoneName = `#${code}-${_zoneName}`;

  const initialValues = {
    buildingId,
    scheduleId,
    status: 'active',
    comment: '',
    impactsBuilding: false,
    zoneName,
    buildingName,
  };

  const validationSchema = Yup.object({
    comment: Yup.string().nullable().required('Input the reason of the service interruption'),
  });

  const formManager = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: ({ buildingId: building_id, scheduleId: serviceId, status, comment, impactsBuilding }) => {
      const interruption = {
        building_id,
        impactsBuilding,
        serviceId,
        status: status || 'active',
        comment,
        userId,
      };

      const mutateProps = { orgSlug, ...interruption };

      createServiceInterruption(mutateProps as any)
        .then(() => {
          next();
        })
        .catch((err) => {
          console.error('error = ', err);
        })
        .finally();
    },
  });

  const loading_form = loading_zone;
  const loading_submit = loading_createServiceInterruption;

  return [{ formManager, loading_form, loading_submit }] as [
    { formManager: FormikProps<typeof initialValues>; loading_form: boolean; loading_submit: boolean },
  ];
};
